class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));

    this.querySelectorAll('[data-close-menu]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => this.close());
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onSummaryClick(event) {
    if (this.mainDetailsToggle.hasAttribute('open') && this.mainDetailsToggle.querySelector('.header__submenu--full')) {
      event.preventDefault();
      this.close();
    }
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.setAttribute('aria-expanded', false);

    if (this.mainDetailsToggle.classList.contains('menu-closing') || !this.mainDetailsToggle.hasAttribute('open')) return;

    const submenu = this.mainDetailsToggle.querySelector('.header__submenu--full');
    if (!submenu) {
      this.mainDetailsToggle.removeAttribute('open');
      return;
    }

    this.mainDetailsToggle.classList.add('menu-closing');

    let animationStart;
    const detailsToggle = this.mainDetailsToggle;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;

      if (time - animationStart < 600) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsToggle.removeAttribute('open');
        detailsToggle.classList.remove('menu-closing');
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
